import React from "react";
import { IChartDataIndicators, IFieldsChart, IChartIndicators } from "../ModalIndicatorChart/interface";

async function mountDefaultValueChart(fullDataChart: IChartDataIndicators[], setFieldsChart: (value: React.SetStateAction<IFieldsChart[]>) => void, setDataChart: (value: React.SetStateAction<IChartIndicators[]>) => void, tendencyString: string){
	let i = -1;
	const newFieldsChart: IFieldsChart[] = fullDataChart && fullDataChart.length > 0 ? fullDataChart.find((x) => x.values.length > 0)?.values.filter((x) => x.showInChart).map((fullValue) => {
		i += 1;
		return {
			dataKey: fullValue.isTendency ? `${tendencyString} - ${fullValue.name}` : fullValue.name,
			chartType: fullValue.chartType,
			showLabel: fullValue.showLabel,
			colorIndex: i,
			customColorForEachBarOfSameData: fullValue.color !== null,
			fieldColor: fullValue.fieldColor,
			axisRight: fullValue.axisY === 2,
			decimalPlaces: fullValue.decimalPlaces
		};
	}) ?? [] : [];
	setFieldsChart(newFieldsChart);

	const newData = fullDataChart.map((fullData) => {
		const newObj: IChartIndicators = {
			name: fullData.name,
			periodId: fullData.values[0]?.periodId || 0,
			hasFCA: fullData.hasFCA
		};
		newObj.comments = [];
		newObj.color = {};
		fullData.values.filter((x) => x.showInChart).forEach((fullValue) => {
			if(fullValue.isTendency)
				newObj[`${tendencyString} - ${fullValue.name}`] = fullValue.value;
			else
				newObj[fullValue.name] = fullValue.value;
				
			if(fullValue.comment && Array.isArray(newObj.comments))
				newObj.comments.push({
					name: fullValue.name,
					text: fullValue.comment
				});

			if(fullValue.color !== null)
				newObj.color[fullValue.name] = fullValue.color;
		});
		return newObj;
	});

	setDataChart(newData);
}

export default mountDefaultValueChart;
